
import { Loader } from 'lucide-react';
import { cn } from '../../utils/cn';
import styles from './Preloader.module.css';
import React from "react";

interface Props {
    title?: string,
    customStyles?: object,
}

const Preloader: React.FC<Props> = ({
    title = 'Загрузка...',
    customStyles = {}
                   }) => {
  return (
    <div style={customStyles} className={cn(styles.fixed, styles.inset0, styles.flex, styles.itemsCenter, styles.justifyCenter, styles.bgWhite80, styles.backdropBlurSm, styles.z50)}>
      <div className={cn(styles.flex, styles.flexCol, styles.itemsCenter, styles.gap4)}>
        <Loader className={cn(styles.h8, styles.w8, styles.animateSpin, styles.textAutopartsOrange)} />
        <p className={cn(styles.textGray600, styles.fontMedium)}>{title}</p>
      </div>
    </div>
  );
};

export default Preloader;
